import classNames from "classnames";
import "./styles.scss";
import { PPDModal } from '../../../../../PPDModal';
import { observer } from 'mobx-react';

type Props = {
    items?: { id: string | number; name: string }[];
    value?: string | number | null;
    current?: { id: string | number; name: string } | null;
    isOpen?: boolean;
    onToggle?: () => void;
    onClose?: () => void;
    onSelect?: (id: string | number) => void;
};

export const PPDWidgetGroupSelectModal = observer(({
    items = [],
    value = null,
    current = null,
    isOpen = false,
    onToggle = () => {},
    onClose = () => {},
    onSelect = () => {},
}: Props) => {

    return (
        <div className="ppd-widget-group-select-modal">
            <button
                type="button"
                className="ppd-widget-group-select-modal__button"
                onClick={onToggle}
            >
                <span>{current?.name ?? ""}</span>
            </button>

            <PPDModal isOpened={isOpen} onClose={onClose}>
                <div className="ppd-widget-group-select-modal__options">
                    {items.map(g => (
                        <div
                            key={g.id}
                            className={classNames("ppd-widget-group-select-modal__option", {
                                "ppd-widget-group-select-modal__option--active": g.id === value,
                            })}
                            onClick={() => onSelect(g.id)}
                        >
                            {g.name}
                        </div>
                    ))}
                </div>
            </PPDModal>
        </div>
    );
});
